export default __webpack_public_path__ + "static/media/maximize.13964f33.svg";